import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import {GoogleAPI} from '../../utils/util-networkCalls.js';
import { useOvermind } from '../../overmind'


const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function AccountDropDown() {
  const classes = useStyles();
  const { state, actions } = useOvermind();

  const handleChange = (event, value) => {
    actions.setAccountIndex(value.props.value);
    // Setting a new account initiates a reset of all data values
    actions.addFormattedData({'name':'liveContainerConfig', 'payload':undefined});
    actions.addFormattedData({'name':'tagDataTable', 'payload':undefined});
    actions.addFormattedData({'name':'variableDataTable', 'payload':undefined});
    actions.addFormattedData({'name':'triggerDataTable', 'payload':undefined});
    actions.getContainerList(undefined);
    actions.setContainerIndex('reset');
    actions.updateFlag({'name':'loadingData','payload':true});
  };

  useEffect(() => {
    if(typeof state.authState.googleAccessToken !== 'undefined' && typeof state.accountList === 'undefined'){
      GoogleAPI('accounts',state.authState.googleAccessToken)
      .then(response =>{
        actions.getAccountList(response.account);
        //console.log(JSON.stringify(response.account));
      });
    }
  });

  if(typeof state.accountList !== 'undefined'){
    return(
      <FormControl variant="filled" className={classes.formControl}>
        <InputLabel id="account-input-label">Accounts</InputLabel>
        <Select
          labelId="account-selection"
          id="account-selection"
          onChange={handleChange}
        >
          {state.accountList.map(account => <MenuItem key={account.accountId} value={account.accountId}>{account.name}</MenuItem>)}
        </Select>
      </FormControl>
    );
  }else{
    return(<CircularProgress />)
  }
}

export default function Account() {
  const { state } = useOvermind();

  return (
    <Grid container direction="column" justify="center" alignItems="center" spacing={2}>
      <Grid item xs={12} md={12} lg={12}>
        <Typography align="center"> Hello {state.authState.firstName}!</Typography>
        <Typography align="center">You are currently logged in as <b>{state.authState.email}.</b></Typography>
        <Typography align="center">Which Google Tag Manager Account would you like to use?</Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <AccountDropDown/>
      </Grid>
    </Grid>

  );
}
